import { connect } from 'react-redux';

import PurchaseExtra from './PurchaseExtra';
import * as actions from '../../modules/TopUps/actions';
import { permanentTopUpSelector, selectedTopUpsPriceSelector, selectedTopUpsSelector } from '../../modules/TopUps';
import { isLoadingSelector } from '../../modules/LoadingStatus';

function mapStateToProps(state) {
  return {
    extraTopUp: permanentTopUpSelector(state),
    selectedTopUps: selectedTopUpsSelector(state),
    price: selectedTopUpsPriceSelector(state),
    isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
  };
}

const mapDispatchToProps = {
  ...actions,
  onConfirm: actions.purchaseExtra,
  fetchAvailableTopUps: actions.fetchAvailablePermanentTopUps,
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseExtra);
